import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { EASE } from "./Reveal";

const MaskedTitle = ({ id, children }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-15%" });
    return (
        <span ref={ref} className="mt-5 block overflow-hidden">
            <motion.h2
                id={id}
                initial={{ y: "112%" }}
                animate={inView ? { y: "0%" } : { y: "112%" }}
                transition={{ duration: 0.85, delay: 0.08, ease: EASE }}
                className="max-w-4xl font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-rz-white sm:text-4xl lg:text-5xl"
            >
                {children}
            </motion.h2>
        </span>
    );
};

export const Section = ({ id, index, label, title, children, alt = false, className = "" }) => (
    <section
        id={id}
        aria-labelledby={`${id}-title`}
        className={`relative border-t border-rz-steel/60 ${alt ? "bg-rz-carbon" : "bg-rz-black"} ${className}`}
    >
        <div className="mx-auto max-w-[1440px] px-5 py-20 sm:px-8 sm:py-24 lg:px-12 lg:py-32">
            <motion.p
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-15%" }}
                transition={{ duration: 0.6, ease: EASE }}
                className="font-display text-[11px] uppercase tracking-[0.2em] text-rz-smoke"
            >
                <span className="text-rz-red">{index}</span>
                <span className="mx-2 text-rz-steel">/</span>
                {label}
            </motion.p>
            <MaskedTitle id={`${id}-title`}>{title}</MaskedTitle>
            {children}
        </div>
    </section>
);
